import { render, staticRenderFns } from "./basic-salary.vue?vue&type=template&id=518235a7&scoped=true&"
import script from "./basic-salary.vue?vue&type=script&lang=js&"
export * from "./basic-salary.vue?vue&type=script&lang=js&"
import style0 from "./basic-salary.vue?vue&type=style&index=0&id=518235a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518235a7",
  null
  
)

export default component.exports